import { render, staticRenderFns } from "./DMIDBrandingNav.vue?vue&type=template&id=66667ca4&scoped=true&"
import script from "./DMIDBrandingNav.vue?vue&type=script&lang=js&"
export * from "./DMIDBrandingNav.vue?vue&type=script&lang=js&"
import style0 from "./DMIDBrandingNav.vue?vue&type=style&index=0&id=66667ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66667ca4",
  null
  
)

export default component.exports